// A sourceId used for messages internally sent by the command handler
export const COMMAND_HANDLER_SOURCE_ID = 'CrmCommandHandlerInternal';